module.exports = __webpack_public_path__ + "img/iconXiTongWuLiaoLieBiao.f4609b48.svg";